/**
 * UI Constants
 * Centralized UI-related constants for consistent styling across the application
 */

/**
 * Standard icon sizes used throughout the application
 */
export const ICON_SIZES = {
  small: { width: 12, height: 12 },
  medium: { width: 16, height: 16 },
  large: { width: 20, height: 20 },
  xlarge: { width: 24, height: 24 }
} as const;

/**
 * Copy button configuration
 */
export const COPY_BUTTON_CONFIG = {
  feedbackDuration: 1500
} as const;

/**
 * Chat message animation configuration
 * Controls the typing animation effect for assistant messages
 */
export const CHAT_ANIMATION_CONFIG = {
  /** Progress thresholds for animation speed */
  progressThresholds: {
    /** Start slow animation for first 20% */
    slowStart: 0.2,
    /** Start slow animation for last 20% */
    slowEnd: 0.8
  },
  /** Animation delays in milliseconds */
  delays: {
    /** Delay for slow animation at start/end (ms) */
    slow: 40,
    /** Delay for fast animation in middle (ms) */
    fast: 15,
    /** Initial delay before starting animation (ms) */
    initial: 30,
    /** Maximum random variation added to base delay (ms) */
    randomVariation: 20
  }
} as const;

export const EXHAUSTED_COLOR = '#D35E0C';
